import { useLazyQuery } from '@apollo/client';
import eventEmitter from 'helpers/event-emitter';
import { ASSET_DUPLICATED } from 'constants/graphqlEvents';
import QUERY_GET_PHOTO from './gql/getPhotoQuery.graphql';
import apiClient from 'helpers/api-client';

const NO_ACTION = null;
const NO_MODAL = () => {};
const EMPTY_RESULT = [NO_ACTION, NO_MODAL];

const databaseIdFrom = (obj) => parseInt(obj.databaseId, 10);

export default function useMenuActionDuplicate({
  assets,
  assetsByType,
  onSuccess,
}) {
  const [getPhoto] = useLazyQuery(QUERY_GET_PHOTO, {
    onCompleted: (data) => {
      if (!data.node) {
        return;
      }
      eventEmitter.trigger(ASSET_DUPLICATED, { assetItem: data.node });
      onSuccess();
    },
  });

  const validSelection =
    assets.length === 1 && assetsByType.photos.length === 1;

  if (!validSelection) {
    return EMPTY_RESULT;
  }

  const action = async () => {
    const photo = assetsByType.photos[0];
    if (!photo) {
      return;
    }

    const photoDatabaseId = databaseIdFrom(photo);

    const { node_id } = await apiClient.post(
      `images/${photoDatabaseId}/duplicate`,
    );

    getPhoto({ variables: { id: node_id } });
  };

  return [action, NO_MODAL];
}
